module.exports = __webpack_public_path__ + "img/banner-38.8c9bdd3e.jpg";